import { WebhookEvents } from "../../../shared/WebhookEvents/WebhookEvents";

export const CopilotApiWebhookEvents = () => <WebhookEvents />;
